
import { getTheme } from 'office-ui-fabric-react/lib/Styling';

const COMBO_BOX_STYLES = {
    label: {
        color: getTheme().palette.neutralTertiary,
        fontSize: 12
    }
};

const DROPDOWN_STYLES = {
    label: {
        color: getTheme().palette.neutralTertiary,
        fontSize: 12
    }
}

const TEXT_BOX_STYLES = {
    subComponentStyles: {
        label: {
            root: {
                color: getTheme().palette.neutralTertiary,
                fontSize: 12
            }
        }
    }
};

const SELECT_ATTR_VALUE_STYLES_OPTIONS = {
    ComboBox: {
        styles: COMBO_BOX_STYLES
    },
    Dropdown: {
        styles: DROPDOWN_STYLES
    },
    TextBox: {
        styles: TEXT_BOX_STYLES        
    }
};

export default {
    COMBO_BOX_STYLES,
    DROPDOWN_STYLES,
    SELECT_ATTR_VALUE_STYLES_OPTIONS,
    TEXT_BOX_STYLES
};
